import {
  ParcelSchema,
  type IParcel,
} from "@redotech/redo-fulfillment-parcel-common/parcel";
import * as z from "zod";
import { null as zNull } from "zod";

export const createParcel = {
  name: "createParcel" as const,
  input: z.object({ parcel: ParcelSchema as IParcel }),
  output: zNull(),
};
